import React, { useState, useRef, useMemo, useEffect } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CREATENEW } from "../../../shared/constants/Constants";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Modalpopup from "../../../shared/components/Modalpopup";
import { useDispatch, useSelector } from "react-redux";
import { changeMessageTemplateStatus, clearMessageTemplateDetail, deleteMessageTemplate, getMessageTemplateById, loadMessageTemplatesList, postMessageTemplate, updateMessageTemplate } from "../redux/Actions";
import Loader from "../../../shared/components/Loader";

const MessageTemplatesList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const quillRef = useRef(null);
  const [showSendModal, setShowSendModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);


  const {
    msgTemplatesList = [],
    templateDetail,
    loading,loadingMsgData
  } = useSelector((state) => state.msgTemplatesList);

  useEffect(() => {
    dispatch(loadMessageTemplatesList());
  }, [dispatch]);

  const transformedData = msgTemplatesList.map((item) => ({
    id: item.id,

    template_name: item.template_name,
    template_message: item.template_message,
    employee_id: item.employee_id,
    emp_name: item.emp_name,
    template_message_plain: item.template_message_plain,
    can_edit_delete: item.can_edit_delete,
    //booleans for checkbox view
    is_shared: item.is_shared,
    is_global: item.is_global,
    is_solution: item.is_solution,

    status: item.is_active,
    created_on: new Date(item.created_on).toLocaleDateString(),
    updated_on: new Date(item.updated_on).toLocaleDateString(),

    raw: item,
  }));


  //  Column definitions
  const messageColumns = [
    {
      display_name: "ID",
      field: "id",
      type: "number",
      hide: true,
    },
    {
      display_name: "Actions",
      field: "actions",
      pinned: "left",
      width: 150,
    },
    {
      display_name: "Template Name",
      field: "template_name",
      type: "text",
      width: 200,
    },

    {
      display_name: "Template Message",
      field: "template_message_plain",
      type: "customLink",
      width: 400,
       functionTo: (row) => handlePreviewTemplate(row),
      // tooltip: "template_message",
    },

    {
      display_name: "Employee",
      field: "emp_name",
      type: "text",
      width: 200,
    },
    {
      display_name: "Solution Template",
      field: "is_solution",
      type: "checkbox",
      width: 25,
    },
    {
      display_name: "Shared",
      field: "is_shared",
      type: "checkbox",
      width: 25,
    },
    {
      display_name: "Global",
      field: "is_global",
      type: "checkbox",
      width: 25,
    },
    
    {
      display_name: "Active Status",
      field: "status",
      type: "customBadge",
      width: 120,
    },
    /* 
    {
      display_name: "Created On",
      field: "created_on",
      type: "text",
      width: 140,
    },

    {
      display_name: "Updated On",
      field: "updated_on",
      type: "text",
      width: 140,
    }, 
    */
  ];

    const sideBarMessageFields = [
    {
      display_name: "Template Name",
      field: "template_name",
      type: "text",
    },
    {
      display_name: "Employee",
      field: "emp_name",
      type: "text",
    },
    /*
    {
      display_name: "Solution Template",
      field: "is_solution",
      type: "checkbox",
    },
    {
      display_name: "Shared",
      field: "is_shared",
      type: "checkbox",
    },
    {
      display_name: "Global",
      field: "is_global",
      type: "checkbox",
    },

    {
      display_name: "Active Status",
      field: "status",
      type: "customBadge",
    },
    */
  ];

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    body: Yup.string().required("Message is required"),
  });

const handleEditMessage = (row) => {
  // The parameter is the entire row object, not just the ID
  const template = row;
  const templateId = template?.id; 

  if (!templateId) {
    console.log("❌ Template ID not found");
    return;
  }

  // Check permission - if can_edit_delete is explicitly false, block action
  if (template.can_edit_delete === false) {    
    return;
  }
  dispatch(getMessageTemplateById(templateId));
  setShowSendModal(true);
};

const handleStatusToggle = (row) => {  

  // The parameter is the entire row object, not just the ID
  const template = row;
  const templateId = template?.id;
  
  if (!templateId) {   
    return;
  }

  // Check permission - if can_edit_delete is explicitly false, block action
  if (template.can_edit_delete === false) {    
    return;
  }  
  setSelectedRow(template);
  setShowStatusModal(true);
};

const handleDeleteTemplate = (id) => {
  // Find the template by id from the transformed data
  const template = transformedData.find(t => t.id === id);

  if (!template || !template.can_edit_delete) return;

  setSelectedRow(template);
  setShowDeleteModal(true);
};


const handleSaveTemplate = (values) => {
  const payload = {
    template_name: values.name,
    template_message: values.body,
    is_shared: values.is_shared,
    is_global: values.is_global,
    is_solution: values.is_solution,
  };

  if (templateDetail?.id) {
    dispatch(updateMessageTemplate(templateDetail.id, payload));
  } else {
    // CREATE
    dispatch(postMessageTemplate(payload));
  }

  setShowSendModal(false);
};

const handleCloseModal = () => {

  setShowSendModal(false);
  dispatch(clearMessageTemplateDetail()); // RESET FORM SOURCE
};

const handleOpenCreateModal = () => {
  // clear edit data first
  dispatch(clearMessageTemplateDetail());

  // then open modal
  setShowSendModal(true);
};
const handlePreviewTemplate = (row) => {
  setSelectedTemplate(row);
  setShowPreviewModal(true);
};

  return (
    <>
      {/* Header */}
      <Row className="detailsPageHeader">
        <Col>
          <Breadcrumbs
            children={[
              { href: "messages/list", label: "Message Templates" }
            ]}
          />
        </Col>
        <Col xs="auto" className="gx-0">
          <DefaultButton
            buttonClass={"default-btn-color"}
            buttonTitle={CREATENEW}
             actionBlock={handleOpenCreateModal}
          />

        </Col>
      </Row>

      {/* ListView */}
      {loading ? (
        <div><Loader /></div>
      ) : (
        <ListView
          columnNames={messageColumns}
          sideBarColumnNames={sideBarMessageFields}
          rowData={transformedData}
          clickEdit={handleEditMessage}
          clickStatus={handleStatusToggle}
          clickDelete={handleDeleteTemplate}          
        />
      )}

      <Modalpopup
        show={showSendModal}
        handleClose={() => setShowSendModal(false)}
        size="lg"
      >
        {/* ===== Modal Header ===== */}
        <div className="d-flex justify-content-between align-items-center pb-2 mb-3">
          <h5 className="mb-0">Message Templates</h5>
          <i
            className="bi bi-x-lg"
            style={{ cursor: "pointer", fontSize: "18px" }}
            onClick={handleCloseModal}
          ></i>
        </div>

        {/* ===== Modal Body ===== */}
          {loadingMsgData ? (
        <div><Loader /></div>
      ) : (
     <Formik
  enableReinitialize
  initialValues={{
    name: templateDetail?.template_name || "",
    body: templateDetail?.template_message || "",
    is_shared: templateDetail?.is_shared || false,
    is_global: templateDetail?.is_global || false,
    is_solution: templateDetail?.is_solution || false,
  }}
  validationSchema={validationSchema}
  onSubmit={(values) => handleSaveTemplate(values)}
>

          {({ values, setFieldValue }) => (
            <Form>
              {/* Name Field */}
              <div className="mb-3">
                <label>
                  <label>
                    <strong>Name (must be unique)</strong>
                  </label>
                </label>
                <Field
                  name="name"
                  className="form-control"
                  placeholder="Enter name"
                />
                <ErrorMessage
                  name="name"
                  component="div"
                  className="text-danger small mt-1"
                />
              </div>

              {/* Message Field */}
              <div className="mb-1" style={{ paddingBottom: "20px" }}>
                <label>
                  <strong>Message</strong>
                </label>

                <div className="quill-wrapper">
                  <ReactQuill
                    ref={quillRef}
                    value={values.body}
                    onChange={(val) => setFieldValue("body", val)}
                  />
                </div>

                <ErrorMessage
                  name="body"
                  component="div"
                  className="text-danger small mt-1"
                />
              </div>
              {/* ===== Shared / Global / Solution Template Checkboxes ===== */}
              <div className="mb-3 ">
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="is_shared"
                    id="is_shared"
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor="is_shared">
                    Shared with team
                  </label>
                </div>

                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="is_global"
                    id="is_global"
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor="is_global">
                    Global
                  </label>
                </div>

                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="is_solution"
                    id="is_solution"
                    className="form-check-input"
                  />
                  <label className="form-check-label" htmlFor="is_solution">
                    Solution Template
                  </label>
                </div>
              </div>

              {/* Footer Buttons */}
              <div className="d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn default-btn-color text-white"
                >
                  Save
                </button>
              </div>
            </Form>
          )}
        </Formik>)}
      </Modalpopup>
    <Modalpopup
  show={showStatusModal}
  handleClose={() => setShowStatusModal(false)}
  actionTitle="Message Template Status"
>
  <p>
    {selectedRow?.status === true ? (
      <>
        Do you want to <strong>Disable</strong>{" "}
        <strong>{selectedRow?.template_name}</strong>?
      </>
    ) : (
      <>
        Do you want to <strong>Enable</strong>{" "}
        <strong>{selectedRow?.template_name}</strong>?
      </>
    )}
  </p>

  <div className="d-flex justify-content-end gap-2">
    <DefaultButton
      buttonClass="btn btn-secondary"
      buttonTitle="Cancel"
      actionBlock={() => setShowStatusModal(false)}
    />

    <DefaultButton
      buttonClass={
        selectedRow?.status === true
          ? "btn btn-danger"   // Disable
          : "btn btn-success"  // Enable
      }
      buttonTitle={
        selectedRow?.status === true
          ? "Disable"
          : "Enable"
      }
      actionBlock={() => {
        dispatch(
          changeMessageTemplateStatus(
           selectedRow.id,
            
          )
        );

        setShowStatusModal(false);
      }}
    />
  </div>
</Modalpopup>

      <Modalpopup
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        actionTitle="Delete Message Template"
      >
        <p>
          Do you want to delete{" "}
          <strong>{selectedRow?.template_name}</strong>
          {" "} template?
        </p>

        <div className="d-flex justify-content-end gap-2">
          <DefaultButton
            buttonClass="btn btn-secondary"
            buttonTitle="Cancel"
            actionBlock={() => setShowDeleteModal(false)}
          />

          <DefaultButton
            buttonClass="btn btn-danger"
            buttonTitle="Delete"
            actionBlock={() => {
              dispatch(deleteMessageTemplate(selectedRow.id));
              setShowDeleteModal(false);
            }}
          />
        </div>
      </Modalpopup>
      <Modal
  show={showPreviewModal}
  onHide={() => setShowPreviewModal(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>
      {selectedTemplate?.template_name || "Message Preview"}
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    {selectedTemplate?.template_message ? (
      <div
        className="border rounded p-3 bg-light"
        style={{ minHeight: "150px" }}
        dangerouslySetInnerHTML={{
          __html: selectedTemplate.template_message,
        }}
      />
    ) : (
      <p>No message content available.</p>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button
      variant="secondary"
      onClick={() => setShowPreviewModal(false)}
    >
      Close
    </Button>
  </Modal.Footer>
</Modal>

    </>
  );
};

export default MessageTemplatesList;
